/* eslint-disable react/react-in-jsx-scope */
import { Link } from "react-router-dom";
import { LuAlignJustify } from "react-icons/lu";
import MaximizeScreen from "./MaximizeScreen";
import LanguageDropdown from "./LanguageDropdown";
import ProfileDropdown from "./ProfileDropdown";
import { logoDarkImg, logoLightImg } from "@/assets/data/images";
import { SidebarContext } from "../../../../context/SidebarContext";
import { useContext, useEffect, useState } from "react";
import OfferAdBanner from "../../../OfferAdBanner";
import { useSelector } from "react-redux";
import { io } from "socket.io-client";

import { useSoundContext } from "../../../../context/SoundContext";

const backendURL = `${import.meta.env.VITE_BACKEND_URL}`;

const TopbarAdmin = () => {
  const { toggleSidebar } = useContext(SidebarContext);
  const { setting } = useSelector((state) => state.settings);
  const [socket, setSocket] = useState(null);
  const [groupedOrders, setGroupedOrders] = useState([]);
  const { isPlaying, setIsPlaying } = useSoundContext();

  useEffect(() => {
    const newSocket = io(backendURL);
    setSocket(newSocket);
    newSocket.emit("waiting-for-orders", 1234);

    return () => {
      newSocket.emit("leaving-the-waiting-for-orders", 1234);
      newSocket.close();
    };
  }, [setSocket]);

  useEffect(() => {
    if (socket) {
      socket.on("grouped-orders", (orders) => {
        setGroupedOrders(orders);
        if (groupedOrders["pending"]?.length > 0) {
          setIsPlaying(true);
        } else {
          setIsPlaying(false);
        }
      });
    }
  }, [socket]);

  return (
    <>
      {!setting?.data?.isAvailableForOrders && <OfferAdBanner />}

      <header className="sticky top-0 z-40 flex h-18 w-full border-b border-default-200 bg-white dark:bg-default-50 lg:ps-64 hide-in-print">
        <nav className="flex w-full items-center gap-4 px-6">
          <div className="flex lg:hidden">
            <button
              type="button"
              className="text-default-500 hover:text-default-600"
              data-hs-overlay="#application-sidebar"
              aria-controls="application-sidebar"
              aria-label="Toggle navigation"
              // onClick={toggleSidebar}
            >
              <LuAlignJustify size={24} />
            </button>
          </div>

          <div className="flex lg:hidden">
            <Link to="/admin/dashboard">
              <img
                src={logoDarkImg}
                height={40}
                width={40}
                alt="logo"
                style={{
                  height: "40px",
                  width: "40px",
                }}
                className="flex dark:hidden"
              />
              <img
                src={logoLightImg}
                height={40}
                width={40}
                alt="logo"
                style={{
                  height: "40px",
                  width: "40px",
                }}
                className="hidden dark:flex"
              />
            </Link>
          </div>

          <div className="ms-auto flex items-center gap-4">
            <div>
              <LanguageDropdown />
            </div>

            <div className="hidden lg:flex">
              <MaximizeScreen />
            </div>

            {/*  <div className="hidden md:flex">
            <NotificationDropdown notifications={notificationsData} />
          </div> */}

            <div className="flex">
              <ProfileDropdown />
            </div>
          </div>
        </nav>
      </header>
    </>
  );
};

export default TopbarAdmin;
